export const LABELS = {
  DASHBOARD: 'Dashboard',
  LEARNERS: 'LEARNERS',
  PROGRESS: 'Progress',
  MANAGEMENT: 'Management',
  IMPACT: 'IMPACT',
  STORIES_OVERVIEW: 'Stories Overview',
  STORY_REVIEW: 'Story Review',
  ENGAGEMENT: 'Engagement',
  MOOD_METER: 'Mood Meter',
  EVENTS: 'Events',
  ACCOUNT_SETTINGS: 'Account Settings',
  LOGOUT: 'Logout',
  RESOURCE_CENTER: 'Resource center'
}

export const LINKS = {
  DASHBOARD: '/',
  PROGRESS: '/progress',
  MANAGEMENT: '/management',
  STORIES_OVERVIEW: '/storiesOverview',
  STORY_REVIEW: '/storyReview',
  ENGAGEMENT: '/engagement',
  MOOD_METER: '/moodMeter',
  ACCOUNT_SETTINGS: '/accountSettings',
  LOGOUT: '/logout',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot',
  ACCOUNT_SETUP: '/account-setup',
  EVENTS: '/events',
  RESOURCE_CENTER: 'https://ojilifelab.com/resource'
}
